export type LastLoginPreference =
  | { method: "google" }
  | { method: "email"; email: string };

export const LAST_LOGIN_STORAGE_KEY = "plutus:last-login:v1";

function normalizePreference(value: unknown): LastLoginPreference | null {
  if (!value || typeof value !== "object") return null;
  const candidate = value as { method?: unknown; email?: unknown };
  if (candidate.method === "google") return { method: "google" };
  if (candidate.method !== "email" || typeof candidate.email !== "string") return null;
  const email = candidate.email.trim().toLowerCase();
  return /^[^\s@]+@[^\s@]+$/.test(email) ? { method: "email", email } : null;
}

export function readLastLoginPreference(): LastLoginPreference | null {
  try {
    const stored = window.localStorage.getItem(LAST_LOGIN_STORAGE_KEY);
    return stored ? normalizePreference(JSON.parse(stored)) : null;
  } catch {
    return null;
  }
}

export function saveLastLoginPreference(preference: LastLoginPreference): void {
  try {
    const normalized = normalizePreference(preference);
    if (normalized) {
      window.localStorage.setItem(LAST_LOGIN_STORAGE_KEY, JSON.stringify(normalized));
    }
  } catch {
    // This display hint must never interrupt authentication.
  }
}
